// extracted by mini-css-extract-plugin
module.exports = {"ModalTitle":"ConfirmModal_ModalTitle__M7BGh","ModalDescription":"ConfirmModal_ModalDescription__1UkrG"};